import { Outlet } from "react-router-dom";

import { MobileNav } from "@/components/navigation/mobile-nav";
import { Sidebar } from "@/components/navigation/sidebar";
import { TopNav } from "@/components/navigation/top-nav";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

export function AppShellLayout() {
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[auto_minmax(0,1fr)]">
      <Sidebar />

      <div className="min-w-0">
        <div className="flex items-center justify-between border-b border-border/70 px-4 py-3 lg:hidden">
          <MobileNav />
          <div className="text-sm font-semibold uppercase tracking-[0.18em] text-muted-foreground">
            PRIMA
          </div>
          <Button variant="outline" size="sm">
            {isMobile ? "Contoh" : "Siap"}
          </Button>
        </div>

        <TopNav />

        <main className="px-4 py-6 md:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
